import AdministrativeRepresentativeForm from './AdministrativeRepresentativeForm';
export default AdministrativeRepresentativeForm;